import { ControlledInput, ControlledPhoneInput, ControlledSwitch } from '@@viewCommonComponents/controlled';
import { FormLayout } from '@@viewCommonComponents/forms/Layouts';
import { emailRules, isMobilePhoneNumberValid, nameIsValid } from '@@viewHelpers/validations';
import { DashedTitle, InfoMessage } from '@fasstech/middle-design-system';
import { useFormContext } from 'react-hook-form';

export const SouscriptionCompanyHRContact = ({
  isDisplayed,
  phoneIndicatives,
  getMiddleBoolean,
  getMiddleText
}) => {
  if (!isDisplayed) return null;

  const form = useFormContext();
  const displayHRContact = form.watch('hrContact.switch');

  return (
    <FormLayout>
      <ControlledSwitch
        name="hrContact.switch"
        label={getMiddleText(
          'ENTREPRISE_CONTACT_RH_AJOUT_TOGGLE_LABEL'
        )}
        form={form}
        withIndicator={false}
        containerClassName="w-full justify-start flex"
        data-testid={'ENTREPRISE_CONTACT_RH_AJOUT_TOGGLE' }
      />
      {displayHRContact && <>
        <DashedTitle>{getMiddleText('ENTREPRISE_CONTACT_RH_TITLE')}</DashedTitle>
        <ControlledInput
          name="hrContact.lastName"
          label={getMiddleText('ENTREPRISE_CONTACT_RH_NOM_LABEL')}
          form={form}
          rules={nameIsValid(true)}
          data-testid="RH_CONTACT_NOM"
        />
        <ControlledInput
          name="hrContact.firstName"
          label={getMiddleText('ENTREPRISE_CONTACT_RH_PRENOM_LABEL')}
          form={form}
          rules={nameIsValid(true)}
          data-testid="RH_CONTACT_PRENOM"
        />

        <ControlledPhoneInput
          name={'hrContact.phones.0'}
          label={getMiddleText('ENTREPRISE_CONTACT_RH_TELEPHONE_LABEL')}
          form={form}
          rules={isMobilePhoneNumberValid(
            getMiddleBoolean('ENTREPRISE_CONTACT_RH_TELEPHONE_OBLIGATOIRE')
          )}
          isInternational
          options={phoneIndicatives || []}
          data-testid="RH_CONTACT_FONCTION_TELEPHONE"
        />
        <InfoMessage iconName={'lightbulb'}>
          {getMiddleText('ENTREPRISE_CONTACT_RH_TELEPHONE_MESSAGE_INFO')}
        </InfoMessage>

        <ControlledInput
          name="hrContact.emails.0.value"
          label={getMiddleText('ENTREPRISE_CONTACT_RH_EMAIL_LABEL')}
          form={form}
          rules={emailRules(getMiddleBoolean('ENTREPRISE_CONTACT_RH_EMAIL_OBLIGATOIRE'))}
          data-testid="RH_CONTACT_EMAIL"
          displayErrorMessage={true}
        />
        <InfoMessage iconName={'lightbulb'}>
          {getMiddleText('ENTREPRISE_CONTACT_RH_EMAIL_MESSAGE_INFO')}
        </InfoMessage>
      </>}
    </FormLayout>
  );
};
